/*
 * HRC v1 site interactions.
 * Loaded site-wide via layout/theme.liquid. Edit here, deploy once, every page updates.
 */
(function () {
  'use strict';

  // -- Mobile burger menu --
  var toggle = document.querySelector('.nav-toggle');
  var menu = document.querySelector('.nav-menu');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      menu.classList.toggle('open');
    });
  }

  // -- Live cart count refresh --
  // Initial value is server-rendered via {{ cart.item_count }} in hrc-header.liquid.
  // This refresh covers the case where Dawn's cart drawer mutates the cart via Ajax
  // (add-to-cart, remove, qty change) and we want the badge to stay in sync.
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var nodes = document.querySelectorAll('.cart-count');
        nodes.forEach(function (node) {
          node.textContent = d.item_count;
          node.setAttribute('data-count', d.item_count);
        });
      })
      .catch(function () { /* swallow */ });
  }

  // Listen for Dawn / Shopify cart change events
  document.addEventListener('cart:updated', refreshCartCount);
  document.addEventListener('cart:refresh', refreshCartCount);

  // Also refresh when window regains focus (in case cart was updated in another tab)
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refreshCartCount();
  });
})();
